import { isEmpty } from 'lodash';
import {
  DirectSalesCampaignDealLineResponse,
  DirectSalesLine,
  DirectSalesStatusOption,
  DirectSalesTransientDealLineState,
} from 'components/common/types/DirectSalesCampaign.types';
import { isDirectSalesLinePriced } from 'components/pages/Planner/hooks/utils/getIsDirectSalesLinePriced';

export const getIsAnyLinePriced = (
  lines: (DirectSalesCampaignDealLineResponse | Partial<DirectSalesLine>)[],
): boolean => {
  return lines.some((line) => Boolean(line.state?.status && isDirectSalesLinePriced(line.state.status)));
};

const isActiveTransientLineStatus = (status: DirectSalesStatusOption): boolean =>
  status !== DirectSalesStatusOption.CANCELLED && status !== DirectSalesStatusOption.DELETED;

export const getIsAnyLinePricedWithTransientStates = (
  lines: (DirectSalesCampaignDealLineResponse | Partial<DirectSalesLine>)[],
  transientLineStates?: DirectSalesTransientDealLineState,
): boolean => {
  if (!isEmpty(transientLineStates)) {
    return Object.values(transientLineStates).some(
      ({ status }) => isActiveTransientLineStatus(status) && isDirectSalesLinePriced(status),
    );
  }

  return getIsAnyLinePriced(lines);
};
